import React, { useMemo } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScollToTop";
import { useUser } from "../../../../pages/Home/UserContext";
import { getUserRoleId } from "../../../config/dashboardMenuConfig";

import { useSubscriptionDashboard } from "./hooks/useSubscriptionDashboard";

import DashboardSubscriptionHeader from "./components/DashboardSubscriptionHeader";
import SubscriptionKpiCards from "./components/SubscriptionKpiCards";
import SubscriptionsTable from "./components/SubscriptionsTable";
import ReferralDiscountsTable from "./components/ReferralDiscountsTable";
import ReferralProgramSection from "./components/ReferralProgramSection";

function getStoredUserInfo() {
  try {
    const raw = localStorage.getItem("userInfo");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function UnauthorizedSubscriptionPanel() {
  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1900px] px-3 sm:px-4 lg:px-6">
        <div className="overflow-hidden rounded-[28px] border border-rose-200 bg-white shadow-sm dark:border-rose-500/20 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-rose-500 to-orange-500" />

          <div className="p-5 sm:p-6">
            <p className="text-[11px] uppercase tracking-[0.22em] text-rose-500">
              Accès refusé
            </p>

            <h1 className="mt-1 text-2xl font-bold text-slate-900 dark:text-white">
              Abonnement & Parrainage
            </h1>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Cette page est réservée aux administrateurs du club.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function AbonnementDashboard() {
  useScrollToTop();

  const { user } = useUser();
  const storedUser = useMemo(() => getStoredUserInfo(), []);
  const roleId = getUserRoleId(user || storedUser);

  const dashboard = useSubscriptionDashboard();

  if (roleId !== 1) {
    return <UnauthorizedSubscriptionPanel />;
  }

  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1900px] space-y-5 px-3 sm:px-4 lg:px-6">
        <DashboardSubscriptionHeader
          loading={dashboard.loading}
          onRefresh={dashboard.fetchSubscriptions}
        />

        <SubscriptionKpiCards
          stats={dashboard.stats}
          loading={dashboard.loading}
        />

        <SubscriptionsTable
          subscriptions={dashboard.subscriptions}
          loading={dashboard.loading}
        />

        <ReferralDiscountsTable
          referrals={dashboard.referrals}
          loading={dashboard.loading}
        />

        <ReferralProgramSection
          showForm={dashboard.showReferralForm}
          setShowForm={dashboard.setShowReferralForm}
          formData={dashboard.referralForm}
          errors={dashboard.referralErrors}
          loading={dashboard.submittingReferral}
          onChange={dashboard.handleReferralChange}
          onSubmit={dashboard.submitReferral}
          onReset={dashboard.resetReferralForm}
        />
      </div>

      <ToastContainer />
    </section>
  );
}
